import { render, staticRenderFns } from "./UploadProgressBar.vue?vue&type=template&id=a6b42f1e"
import script from "./UploadProgressBar.vue?vue&type=script&lang=ts"
export * from "./UploadProgressBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports